import React from 'react';
import { CardActions, ListButton, RefreshButton } from 'react-admin';
import ReferenceAddButton from 'components/ReferenceAddButton';
import { ContactInfoIcon } from '../ContactInfo';
import { SalesAdvisorIcon } from '../SalesAdvisor';
import { ServiceConsultantIcon } from '../ServiceConsultant';

const EditActions = ({ basePath, data, permissions, gotPermission, resource }) => {
  return (
    <CardActions>
      <RefreshButton />
      {gotPermission(permissions, 'brands') && <ListButton basePath={basePath} />}
      {gotPermission(permissions, 'contactinfos') && (
        <ReferenceAddButton
          source="brand_id"
          reference="contactinfos"
          record={data}
          label="Add Contact Info"
          icon={<ContactInfoIcon />}
        />
      )}
      {gotPermission(permissions, 'sales_advisors') && (
        <ReferenceAddButton
          source="brand_id"
          reference="sales_advisors"
          label="Add Sales Consultant"
          record={data}
          icon={<SalesAdvisorIcon />}
        />
      )}
      {gotPermission(permissions, 'service_consultants') && (
        <ReferenceAddButton
          source="brand_id"
          reference="service_consultants"
          label="Add Service Consultant"
          record={data}
          icon={<ServiceConsultantIcon />}
        />
      )}
    </CardActions>
  );
};

export default EditActions;



// WEBPACK FOOTER //
// ./src/containers/CarBrand/EditActions.js